import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage > 0 ? idHotsiteLocalStorage : 5,
  Loja: "Ouro Puro",
  UserStorage: "bK4/XR3kDkGQmN4otNxlaQ==",
  UserToken: "KqtiU6QnxkeDrbmqfU2eZA==",
  UrlApi: "https://prd-ecommerce-und-api.primecase.com.br/api",
  UrlLoja:"https://ouropuro.com/",
  UrlServiceHost: "https://prd-und-svc-api.primecase.com.br/",
  OrgId: "9ozphlqx",
  ProviderMerchantId: "braspag_marlim_advanced",
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#24324f",
      light: "#977a21",
      //lighter: "#ece6f7",
      dark: darkenColor("#977a21", 10), // Escurece em 20%
    },
    secondary: {
      main: "#000",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
